import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from './Button';
import { ModalHeader } from './ModalHeader';
import { i18n } from '../i18n/translate';

const RULE_SET_BUTTONS = Object.freeze([
  {
    ruleSet: 'he_admin',
    label: i18n.t('Higher Education Students'),
  },
  {
    ruleSet: 'fac_staff_admin',
    label: i18n.t('Faculty & Staff'),
  },
  {
    ruleSet: 'cc_admin',
    label: i18n.t('Employees'),
  },
  {
    ruleSet: 'scorm_manager',
    label: i18n.t('Scorm'),
  },
]);

export const RuleSetModal = ({ container, href, onCancel, ruleSets = [], show }) => {
  const [ruleSet, setRuleSet] = useState();
  const [containerElem, setContainerElem] = useState(container);
  const isCancelable = !!onCancel;
  const ruleSetButtons = RULE_SET_BUTTONS.filter(ruleSetButton => ruleSets.includes(ruleSetButton.ruleSet));

  useEffect(() => {
    // we need to do this in useEffect since this component is rendered server-side, making document object not available
    if (!containerElem) {
      setContainerElem(document.querySelector('body'));
    }
  }, [containerElem]);

  if (!containerElem || ruleSetButtons.length < 2) return null;

  const handleOnCancel = () => {
    setRuleSet();
    onCancel();
  };

  const getRedirectHref = () => {
    const url = href.split('#');
    url[0] += `?current_rule_set_name=${ruleSet}`;
    return url.join('#');
  };

  return (
    <Modal
      animation={false}
      aria-labelledby="rule-set-modal-title"
      className="rule-set-modal modal-size-small"
      dialogClassName="foundry"
      id="rule-set-modal"
      show={show}
      container={containerElem}
    >
      <ModalHeader
        canClickOff={isCancelable}
        className="rule-set-modal-title"
        closeButton={false}
        description={i18n.t(
          'Select the population you are here to train or the admin settings you would like to manage.'
        )}
        onCancel={handleOnCancel}
        title={i18n.t('Select a Population')}
        titleId="rule-set-modal-title"
      />
      <Modal.Body>
        {ruleSetButtons.map(({ ruleSet: rs, label }) => (
          <Button
            key={rs}
            block={true}
            data-object-type="reports"
            data-action="select-population"
            data-object-id={rs}
            className={`large${rs === ruleSet ? ' selected' : ''}`}
            label={label}
            onClick={() => setRuleSet(rs)}
            style="pill"
            renderAsLegacy
          />
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button
          block={true}
          className="large"
          disabled={!ruleSet}
          href={getRedirectHref()}
          data-object-type="reports-navigation"
          data-action="select-population-next"
          label={i18n.t('Next')}
          style="primary"
          renderAsLegacy
        />
        {isCancelable && (
          <Button
            block={true}
            label={i18n.t('Cancel')}
            data-object-type="reports-navigation"
            data-action="select-population-cancel"
            onClick={handleOnCancel}
            style="link"
            renderAsLegacy
          />
        )}
      </Modal.Footer>
    </Modal>
  );
};

RuleSetModal.propTypes = {
  container: PropTypes.node,
  href: PropTypes.string,
  onCancel: PropTypes.func,
  ruleSets: PropTypes.array,
  show: PropTypes.bool,
};
